export enum PriceRequestEquipment {
  'reefer53' = "53' Reefer",
  'van53' = "53' Van",
  'reefer' = 'Reefer',
  'dryVan' = 'Dry Van',
  'flatbed53' = "53' Flatbed",
  'flatbed48' = "48' Flatbed",
}

export const REEFER_53_ID = 8
export const VAN_53_ID = 12
export const REEFER_ID = 2
export const DRY_VAN_ID = 3
export const FLATBED_53_ID = 4
export const FLATBED_48_ID = 5
